import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/ignoreElements';
import type { ActionsObservable } from 'redux-observable';
import type { Action } from '../../state/actions';
import { getIsAdmin } from '../../state/context/selectors';
import type { AppState } from '../../state/types';
import { ARCHIVE_PROJECT_SUCCESS } from '../../state/ui/actions';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>, store: MiddlewareAPI<AppState>) =>
	action$
		.ofType(ARCHIVE_PROJECT_SUCCESS)
		.do(({ payload }) => {
			const { replace } = payload;
			const isAdmin = getIsAdmin(store.getState());
			if (isAdmin) {
				replace('/jira/settings/projects/manage');
			} else {
				replace('/jira/projects');
			}
		})
		.ignoreElements();
